module.exports = __webpack_public_path__ + "static/media/locations-placeholder.7d1644e2.webp";